module.exports = __webpack_public_path__ + "static/img/dz.4be984a3.svg";